import Container from './PublishedPageContent.container';
import Component from './PublishedPageContent';
export default Container(Component);
